import React from "react";
import { Box, Typography, Grid, Container } from "@mui/material";
import guru1 from "../images/Sri Sir Ravi Shankar.jpg";
import guru2 from "../images/2-Swami-Veththiri-Maharishi.jpg";
import guru3 from "../images/B K S Iyengar.jpg";
import guru4 from "../images/lord shiva.jpg";

const AboutGurusPage = () => {
  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Typography
        variant="h3"
        align="center"
        gutterBottom
        sx={{mb: 4, fontFamily: "Cinzel Decorative, cursive", fontWeight: 800, lineHeight: 1.5, opacity: 0.7 }}
      >
        Our Guru's
      </Typography>
      <Grid container spacing={3} justifyContent="center">
        {/* Guru 1 */}
        <Grid item xs={12} sm={3}>
          <Box
            sx={{
              textAlign: "center",
              border: "1px solid #ddd",
              borderRadius: 2,
              backgroundColor: "#fff",
              height: "100%", // Ensure the card takes full height of the grid item
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <img
              src={guru4}
              alt="Sri Sri Ravi Shankar"
              style={{ width: "100%", height: "450px", objectFit: "inherit" }} // Fixed height for all images
            />
            <Typography variant="body1" sx={{ mt: 2, fontWeight: 500 }}>
              Aadi Yogi
            </Typography>
          </Box>
        </Grid>

        {/* Guru 2 */}
        <Grid item xs={12} sm={3}>
          <Box
            sx={{
              textAlign: "center",
              border: "1px solid #ddd",
              borderRadius: 2,
              backgroundColor: "#fff",
              height: "100%", // Ensure the card takes full height of the grid item
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <img
              src={guru2}
              alt="Swami Vethathiri Maharishi"
              style={{ width: "100%", height: "450px", objectFit: "inherit" }} // Fixed height for all images
            />
            <Typography variant="body1" sx={{ mt: 2, fontWeight: 500 }}>
              Swami Vethathiri Maharishi
            </Typography>
          </Box>
        </Grid>

        {/* Guru 3 */}
        <Grid item xs={12} sm={3}>
          <Box
            sx={{
              textAlign: "center",
              border: "1px solid #ddd",
              borderRadius: 2,
              backgroundColor: "#fff",
              height: "100%", // Ensure the card takes full height of the grid item
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <img
              src={guru3}
              alt="B K S Iyengar"
              style={{ width: "100%", height: "450px", objectFit: "inherit" }} // Fixed height for all images
            />
            <Typography variant="body1" sx={{ mt: 2, fontWeight: 500 }}>
              B K S Iyengar
            </Typography>
          </Box>
        </Grid>

        {/* Guru 4 */}
        <Grid item xs={12} sm={3}>
          <Box
            sx={{
              textAlign: "center",
              border: "1px solid #ddd",
              borderRadius: 2,
              backgroundColor: "#fff",
              height: "100%", // Ensure the card takes full height of the grid item
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <img
              src={guru1}
              alt="B K S Iyengar"
              style={{ width: "100%", height: "450px", objectFit: "inherit" }} // Fixed height for all images
            />
            <Typography variant="body1" sx={{ mt: 2, fontWeight: 500 }}>
              Sri Sir Ravi Shankar
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
};

export default AboutGurusPage;
